import React, { useEffect, useState } from 'react';
import {
  Button,
  Grid,
  Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Paper, TextField,
  TableSortLabel, TablePagination,
  Dialog, DialogTitle, DialogContent, DialogActions,
  List, ListItem, ListItemText
} from '@material-ui/core';

import SharedTitle from './SharedForms/SharedTitle';
import ModalCreatePersonel from './ModalCreatePersonel';
import ModalViewPersonel from './ModalCreatePersonel';
import CloudDownloadOutlinedIcon from '@material-ui/icons/CloudDownloadOutlined';
import CloudUploadOutlinedIcon from '@material-ui/icons/CloudUploadOutlined';

import {
  deletePersonal,
  getAntiguedad,
  getDataTableDotacionPersonal,
  getProfesiones,
  getSexo,
  getTipoContrato,
  getTipoJornada,
  getUnidadFuncional,
  downloadCargaMasivaXls,
  subirCargaMasivaFt
} from 'services/api';

import { DESC_DOTACION_PERSONAL } from 'config/config';
import Spinner from '@jumbo/components/custom/Spinner';
import { CustomToast, toast } from '@jumbo/components/custom/Toast';
import { IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

import PersonAddOutlinedIcon from '@material-ui/icons/PersonAddOutlined';

/* -----------------------------------------------------------
   ✔ MODAL RESULTADO DE CARGA MASIVA
------------------------------------------------------------ */
const ModalResultadoCarga = ({ open, onClose, resultados }) => {
  const totalOK = resultados?.total_ok ?? 0;
  const errores = resultados?.errores ?? [];

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle style={{ fontWeight: "bold" }}>
        Resultado de la Carga Masiva
      </DialogTitle>

      <DialogContent dividers style={{ maxHeight: 400 }}>
        <p>
          <strong>Registros cargados correctamente:</strong>{" "}
          <span style={{ color: "green" }}>{totalOK}</span>
        </p>

        <p>
          <strong>Registros con errores:</strong>{" "}
          <span style={{ color: "red" }}>{errores.length}</span>
        </p>

        {errores.length === 0 && (
          <p style={{ color: "green", marginTop: 20 }}>
            ✔ No se encontraron errores. Todo perfecto.
          </p>
        )}

        {errores.length > 0 && (
          <List>
            {errores.map((item, idx) => (
              <ListItem key={idx} divider>
                <ListItemText
                  primary={
                    <span style={{ fontWeight: "bold", color: "red" }}>
                      ❌ Fila {item.fila}
                    </span>
                  }
                  secondary={item.detalle}
                />
              </ListItem>
            ))}
          </List>
        )}
      </DialogContent>

      <DialogActions>
        <Button
          onClick={onClose}
          color="primary"
          variant="contained"
          style={{ textTransform: "none", borderRadius: 8 }}
        >
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};



/* -----------------------------------------------------------
   ✔ TABLA MODERNA
------------------------------------------------------------ */
const ModernTable = ({ rows, fields, onEdit, onDelete }) => {
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState(fields[0].id);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleSort = property => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const comparator = (a, b) => {
    if (b[orderBy] < a[orderBy]) return order === 'asc' ? 1 : -1;
    if (b[orderBy] > a[orderBy]) return order === 'asc' ? -1 : 1;
    return 0;
  };

  const sorted = [...rows].sort(comparator);

  const filtered = sorted.filter(row =>
    Object.values(row).some(v =>
      String(v).toLowerCase().includes(search.toLowerCase())
    )
  );

  return (
    <Paper elevation={0} style={{
      margin: 25,
      borderRadius: 12,
      border: 'none',
      boxShadow: 'none'
    }}>

      <div style={{ padding: 16, display: "flex", justifyContent: "flex-end" }}>
        <TextField
          label="Buscar..."
          variant="outlined"
          size="small"
          value={search}
          onChange={e => setSearch(e.target.value)}
          style={{ width: 280 }}
        />
      </div>

      <TableContainer style={{ maxHeight: 470, backgroundColor: "white" }}>
        <Table stickyHeader>

          <TableHead>
            <TableRow>
              {fields.map(col => (
                <TableCell
                  key={col.id}
                  style={{ fontWeight: 'bold', borderBottom: '0px', padding: "6px" }}
                >
                  <TableSortLabel
                    active={orderBy === col.id}
                    direction={orderBy === col.id ? order : 'asc'}
                    onClick={() => handleSort(col.id)}
                  >
                    {col.label}
                  </TableSortLabel>
                </TableCell>
              ))}

              <TableCell style={{ fontWeight: 'bold', borderBottom: '0px', padding: "6px" }} align="center">
                Acciones
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {filtered
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => (
                <TableRow
                  key={index}
                  hover
                  style={{
                    height: 32,
                    borderBottom: "0px"
                  }}
                >
                  {fields.map(col => (
                    <TableCell key={col.id} style={{ padding: "4px 10px", fontSize: "13px" }}>
                      {row[col.id]}
                    </TableCell>
                  ))}

                  <TableCell align="center" style={{ padding: "4px 10px", display: "flex", justifyContent: "center", gap: "8px" }}>
                    <IconButton
                      size="small"
                      onClick={() => onEdit(row)}
                      title="Editar"
                    >
                      <EditIcon style={{ color: "#4CAF50" }} />  {/* Verde claro */}
                    </IconButton>

                    <IconButton
                      size="small"
                      color="error"
                      onClick={() => onDelete(row)}
                      title="Eliminar"
                    >
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>

                </TableRow>
              ))}
          </TableBody>

        </Table>
      </TableContainer>

      <TablePagination
        rowsPerPageOptions={[10, 20, 50]}
        component="div"
        count={filtered.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={(e, newPage) => setPage(newPage)}
        onRowsPerPageChange={e => {
          setRowsPerPage(parseInt(e.target.value, 10));
          setPage(0);
        }}
        labelRowsPerPage="Filas por página:"   // 👈 ESTO LO CAMBIA A ESPAÑOL
      />

    </Paper>
  );
};



/* -----------------------------------------------------------
   ✔ COMPONENTE PRINCIPAL
------------------------------------------------------------ */
const DotacionMenuChildren = props => {

  const [openDialog, setOpenDialog] = useState(false);
  const [openView, setOpenView] = useState(false);
  const [selectedRow, setSelectedRow] = useState('');

  const [listaSexo, setListaSexo] = useState([]);
  const [listaProfesion, setListaProfesion] = useState([]);
  const [listaTipoJornada, setListaTipoJornada] = useState([]);
  const [listaTipoContrato, setListaTipoContrato] = useState([]);
  const [unidadesList, setUnidadesList] = useState([]);

  const [filas, setFilas] = useState([]);
  const [reload, setReload] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [loadingUpload, setLoadingUpload] = useState(false);

  const [openResultado, setOpenResultado] = useState(false);

  /* 🔥 ESTADO CORRECTO */
  const [resultadoCarga, setResultadoCarga] = useState({
    total_ok: 0,
    errores: []
  });



  /* -----------------------------------------------------------
      ✔ CARGA DE LISTAS
  ------------------------------------------------------------ */
  useEffect(() => {
    getTipoJornada()
      .then(res => setListaTipoJornada([{ id: 'seleccione', tipo_jornada: 'Seleccione' }, ...res.data]))
      .catch(console.error)
      .finally(() => {
        getTipoContrato()
          .then(res => setListaTipoContrato([{ id: 'seleccione', tipo_contrato: 'Seleccione' }, ...res.data]))
          .catch(console.error)
          .finally(() => {
            getProfesiones()
              .then(res => setListaProfesion([{ id: 'seleccione', profesion: 'Seleccione' }, ...res.data]))
              .catch(console.error)
              .finally(() => {
                getSexo()
                  .then(res => setListaSexo(res.data))
                  .catch(console.error)
                  .finally(() => {
                    
                      getUnidadFuncional()
                        .then(res => {
                          const aux = [{ id: 'seleccione', value: 'Seleccione' }];
                          res.data.forEach(i => aux.push({ id: i.id, value: i.nombre }));
                          setUnidadesList(aux);
                        })
                        .catch(console.error);
                    
                  });
              });
          });
      });
  }, []);



  /* -----------------------------------------------------------
      ✔ CARGA DE TABLA
  ------------------------------------------------------------ */
  useEffect(() => {
    if (listaProfesion.length > 0 && listaTipoJornada.length > 0) {

      setIsLoading(true);

      getDataTableDotacionPersonal(sessionStorage.getItem('idFicha'))
        .then(res => {
          const aux = res.data.map(item => ({
            ...item,
            rut: item.persona.rut + '-' + item.persona.dv,
            nombre_completo: `${item.persona.nombres} ${item.persona.apellido_paterno} ${item.persona.apellido_materno}`,
            profesion_table: listaProfesion.find(e => e.id === item.persona.id_profesion)?.profesion ?? '',
            n_registro_super: item.persona.nro_registro,
            tipo_jornada_table: item.tipo_jornada,
            unidad_funcional_desempeño: item.unidad_funcional,
            id_asociacion: item.id,
            persona_id: item.persona.id
          }));

          setFilas(aux);
        })
        .catch(console.error)
        .finally(() => setIsLoading(false));
    }
  }, [listaProfesion, listaTipoJornada, reload]);



  /* -----------------------------------------------------------
      ✔ ELIMINAR REGISTRO
  ------------------------------------------------------------ */
  const handleDelete = (row) => {
    deletePersonal(sessionStorage.getItem('idFicha'), row.persona.id)
      .finally(() => setReload(!reload));
  };



  /* -----------------------------------------------------------
      ✔ DESCARGAR PLANTILLA
  ------------------------------------------------------------ */
  const descargarPlantilla = () => {
    downloadCargaMasivaXls()
      .then(res => {
        const blob = new Blob([res.data]);
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = "carga_masiva_personal_fichas_tecnicas.xlsx";
        a.click();
        URL.revokeObjectURL(url);
      })
      .catch(() => toast.error("Error al descargar plantilla"));
  };



  /* -----------------------------------------------------------
      ✔ SUBIR ARCHIVO + MOSTRAR MODAL
  ------------------------------------------------------------ */
  const handleUploadFile = e => {
    const file = e.target.files[0];
    if (!file) return;

    if (file.name !== "carga_masiva_personal_fichas_tecnicas.xlsx") {
      toast.error('El archivo debe llamarse "carga_masiva_personal_fichas_tecnicas.xlsx".');
      return;
    }

    setLoadingUpload(true);

    let form = new FormData();
    form.append("file", file);

    subirCargaMasivaFt(form, sessionStorage.getItem("idFicha"))
      .then(res => {
        toast.success("Archivo cargado correctamente.");

        const r = res.data;
        console.log("RAW API RESPONSE:", r);

        const resultados = {
          total_ok: r?.total_ok ?? 0,
          errores: r?.errores ?? []
        };

        console.log("RESULTADOS NORMALIZADOS:", resultados);

        setResultadoCarga(resultados);
        setOpenResultado(true);

        setReload(!reload);
      })
      .catch(() => toast.error("Error al cargar archivo"))
      .finally(() => setLoadingUpload(false));
  };



  /* -----------------------------------------------------------
      ✔ CAMPOS TABLA
  ------------------------------------------------------------ */
  const fields = [
    { id: 'rut', label: 'RUT' },
    { id: 'nombre_completo', label: 'Nombre' },
    { id: 'profesion_table', label: 'Profesión' },
    { id: 'n_registro_super', label: 'Registro' },
    { id: 'tipo_jornada_table', label: 'Jornada' },
    { id: 'unidad_funcional_desempeño', label: 'Unidad Funcional' }
  ];



  /* -----------------------------------------------------------
      ✔ RENDER PRINCIPAL
  ------------------------------------------------------------ */
  return (
    <>
      <CustomToast />

      {/* MODALES */}
      <ModalCreatePersonel
        reload={() => setReload(!reload)}
        openDialog={openDialog}
        close={() => setOpenDialog(false)}
        contratos={listaTipoContrato}
        profesiones={listaProfesion}
        jornadas={listaTipoJornada}
        unidadesList={unidadesList}
        sexos={listaSexo}
      />

      <ModalViewPersonel
        reload={() => setReload(!reload)}
        openDialog={openView}
        close={() => setOpenView(false)}
        selectedRow={selectedRow}
        setSelectedRow={setSelectedRow}
        isEdit
        contratos={listaTipoContrato}
        profesiones={listaProfesion}
        jornadas={listaTipoJornada}
        unidadesList={unidadesList}
        sexos={listaSexo}
      />

      {/* ✔ MODAL DE RESULTADO DE CARGA */}
      <ModalResultadoCarga
        open={openResultado}
        onClose={() => setOpenResultado(false)}
        resultados={resultadoCarga}
      />

      <div style={{ width: '100%', backgroundColor: 'white', height: '100%' }}>

        <SharedTitle title={'Dotación de personal'} />

        <Grid item xs={12} style={{ padding: 25 }}>
          {/* <p>{DESC_DOTACION_PERSONAL}</p> */}
          <p>
            En este módulo del sistema, se realizará la carga del personal de salud del
            prestador institucional, esta funcionalidad está conectada al Registro
            Nacional de Prestadores Individuales, por lo cual hay información que se
            cargará automáticamente. para poblar los datos. Para facilitar el llenado,
            usted podrá realizar una carga masiva de profesionales, en una Plantilla con
            formato y la Información con los códigos que se deben utilizar para las
            columnas de sexo, profesión, tipo de jornada, tipo de contrato, unidad
            funcional y objetor de conciencia.
          </p>
        </Grid>

        {/* ✔ BOTONES */}
        <Grid container item xs={12} spacing={2} style={{ paddingLeft: 25 }}>

          <Grid item>
            <Button
              variant="outlined"
              color="primary"
              startIcon={<PersonAddOutlinedIcon />}
              style={{
                textTransform: "none",
                padding: "6px 20px",
                borderRadius: 8
              }}
              onClick={() => setOpenDialog(true)}
            >
              Agregar Personal
            </Button>
          </Grid>

          {/*           <Grid item>
            <Button
              variant="outlined"
              color="primary"
              startIcon={<CloudDownloadOutlinedIcon />}
              style={{
                textTransform: "none",
                padding: "6px 20px",
                borderRadius: 8
              }}
              onClick={descargarPlantilla}
            >
              Descargar Plantilla
            </Button>
          </Grid>

          <Grid item>
            <Button
              variant="outlined"
              component="label"
              startIcon={<CloudUploadOutlinedIcon />}
              style={{
                textTransform: "none",
                padding: "6px 20px",
                borderRadius: 8,
                color: "#2e7d32",
                borderColor: "#2e7d32"
              }}
            >
              Carga Masiva Personal
              <input hidden accept=".xlsx" type="file" onChange={handleUploadFile} />
            </Button>
          </Grid> */}

        </Grid>


        {/* ✔ TABLA */}
        <Grid item xs={12} style={{ backgroundColor: "white" }}>
          {isLoading ? (
            <div style={{ display: 'flex', justifyContent: 'center', padding: 40 }}>
              <Spinner show />
            </div>
          ) : filas.length > 0 ? (
            <ModernTable
              rows={filas}
              fields={fields}
              onEdit={(row) => {
                setSelectedRow(row);
                setOpenView(true);
              }}
              onDelete={handleDelete}
            />
          ) : (
            <div style={{ padding: 20, textAlign: "center", color: "#999" }}>
              No hay registros para mostrar.
            </div>
          )}
        </Grid>


      </div>
    </>
  );
};

export default DotacionMenuChildren;
